import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
import { zfcfsv } from "./zfc_video";
import { zfc } from "./zfc_global";
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from "swiper/modules";
export class zfctl {
    static tryPlayWhenVisible(scope) {
        var retries = 0;
        var maxRetries = 20;
        var tryPlay = function () {
            var playButton = scope.find('.playkit-pre-playback-play-button');
            if (playButton.is(":visible")) {
                playButton.click();
                return;
            }
            retries++;
            if (retries < maxRetries) {
                setTimeout(tryPlay, 250);
            }
        };
        tryPlay();
    }
    static loadImage(item) {
        item.find('img[data-src]').attr("src", item.find('img').data("src"));
        return true;
    }
    ;
    static eventHoverIn(item) {
        var that = item;
        if (that.closest(".zfctt-teaser-social").length) {
            return;
        }
        var v = {
            container: that.outerHeight(),
            text: (that.find(".zfctl-item-text .zfctl-item-context-body.active").length ? that.find(".zfctl-item-text").prop('scrollHeight') : 0),
            max: 0
        };
        v.max = v.container;
        that.find(".zfctl-item-content-bg, .zfctl-item-content").finish();
        that.find(".zfctl-item-text").animate({ "min-height": v.text }, { duration: 500, queue: false });
        that.find(".zfctl-item-content-bg, .zfctl-item-content, .zfctl-item-text").animate({ "min-height": v.max }, { duration: 500, queue: false });
        that.find(".zfctl-item-content").addClass("zfctl-item-content-adjusted");
    }
    ;
    static eventHoverOut(item) {
        var that = item;
        that.find(".zfctl-item-content").removeClass("zfctl-item-content-adjusted");
        that.find(".zfctl-item-content-bg, .zfctl-item-content").finish();
        that.find(".zfctl-item-content-bg, .zfctl-item-content").animate({ "min-height": 278 }, { duration: 500, queue: false });
        that.find(".zfctl-item-text").animate({ "min-height": 90 }, { duration: 500, queue: false });
    }
    ;
    static listPagination(wordsList, maxCharLen) {
        var stringCharLen = 0;
        var approvedStr = "";
        for (let word of wordsList) {
            if (stringCharLen >= maxCharLen) {
                approvedStr = approvedStr;
                break;
            }
            else if (stringCharLen < maxCharLen) {
                stringCharLen = stringCharLen + word.length + 1;
                approvedStr = approvedStr + word + " ";
                if (stringCharLen >= maxCharLen) {
                    break;
                }
            }
        }
        ;
        return [stringCharLen, approvedStr];
    }
    static prevListPagination(prevString, maxCharLen) {
        var approvedStr = "";
        var adjustCharLen = 0;
        var listStr = [];
        if (prevString.length > 0) {
            listStr = zfctl.listPagination(prevString, maxCharLen);
            if (listStr[0] < maxCharLen) {
                adjustCharLen = listStr[0];
            }
            approvedStr = "<li> ..." + listStr[1] + "</li>";
        }
        return [adjustCharLen, approvedStr];
    }
    static removeSpaces(wordsList) {
        for (var i = 0; i < wordsList.length; i++) {
            if (wordsList[i] == '') {
                wordsList.splice(i, 1);
                i--;
            }
        }
        return wordsList;
    }
    static eventContentPagination(item, maxChar) {
        var that = item;
        var stringList = [];
        var maxCharLen = that.find(".zfctl-item-headline").length == 0 ? maxChar : maxChar - that.find(".zfctl-item-headline").text().length;
        var adjustCharLen = 0;
        var contextString = that.find(".zfctl-item-context-body").text();
        var contextHTML = that.find(".zfctl-item-context-body").html();
        var contextLen = contextString.length;
        var contextHTMLLen = contextHTML.length;
        if ((contextLen > maxCharLen || contextHTMLLen > maxCharLen) && that.find(".zfctl-item-context-body").length == 1) {
            var currIndex = 0;
            var matchType = "";
            var readmoreContainer = "<div class='zfctl-item-controls'><button class='zfctl-btn-prev' aria-label='Event Content Previous'></button><div class='zfctl-rm-count'></div><button class='zfctl-btn-next' aria-label='Event Content Next'></button></div></div>";
            if (contextHTML.match(/<li\b[^>]*>(.*?)<\/li>/g) == null) {
                matchType = "String";
                var wordsList = contextString.split(" ");
                var approvedStr = "";
                var stringCharLen = 0;
                var wordIndex = 0;
                var matchIndex = 0;
                if (stringList.length > 0) {
                    maxCharLen = 350;
                }
                for (let word of wordsList) {
                    if (stringCharLen < maxCharLen) {
                        stringCharLen = stringCharLen + word.length + 1;
                        approvedStr = approvedStr + word + " ";
                        wordIndex = wordIndex + 1;
                        if (stringCharLen + word.length > maxCharLen || wordIndex == wordsList.length) {
                            if (matchIndex == 0 && wordIndex != wordsList.length) {
                                stringList.push(approvedStr + "...");
                                if (stringList.length > 0) {
                                    maxCharLen = 350;
                                }
                            }
                            else if (matchIndex > 0 && wordIndex == wordsList.length) {
                                stringList.push("..." + approvedStr);
                                if (stringList.length > 0) {
                                    maxCharLen = 350;
                                }
                            }
                            else {
                                stringList.push("..." + approvedStr + "...");
                                if (stringList.length > 0) {
                                    maxCharLen = 350;
                                }
                            }
                            approvedStr = "";
                            stringCharLen = 0;
                            matchIndex = matchIndex + 1;
                        }
                    }
                }
                ;
            }
            else {
                var prevString = [];
                var prevListStr = [];
                matchType = "HTML";
                var approvedStr = "";
                contextHTML.match(/<li\b[^>]*>(.*?)<\/li>/g).forEach(function (value, index, array) {
                    var newVal = value.replace("<li>", "").replace("</li>", "");
                    var wordsList = newVal.split(" ");
                    var adjustedWordsList = [];
                    var listStr = [];
                    if (stringList.length > 0) {
                        maxCharLen = 350;
                    }
                    if (prevString.length > 0) {
                        prevListStr = zfctl.prevListPagination(prevString, maxCharLen);
                        adjustCharLen = prevListStr[0];
                        approvedStr = prevListStr[1];
                        prevListStr = [];
                    }
                    zfctl.removeSpaces(wordsList);
                    listStr = zfctl.listPagination(wordsList, maxCharLen - adjustCharLen);
                    if (listStr[0] < maxCharLen) {
                        adjustCharLen = listStr[0];
                    }
                    adjustedWordsList = listStr[1].split(" ");
                    zfctl.removeSpaces(adjustedWordsList);
                    if (wordsList.length == adjustedWordsList.length && adjustCharLen < maxCharLen) {
                        console.log("list item approved");
                        approvedStr = approvedStr + "<li>" + listStr[1] + "</li>";
                    }
                    else {
                        console.log("remove words already approved");
                        approvedStr = approvedStr + "<li>" + listStr[1] + "... </li>";
                        for (var i = 0; i <= wordsList.length; i++) {
                            if (wordsList[i] == adjustedWordsList[i]) {
                                wordsList.splice(i, 1);
                                adjustedWordsList.splice(i, 1);
                                i--;
                            }
                            else {
                                break;
                            }
                        }
                        prevString = wordsList;
                    }
                    if ((approvedStr.length >= maxCharLen) || index == contextHTML.match(/<li\b[^>]*>(.*?)<\/li>/g).length - 1) {
                        stringList.push("<ul>" + approvedStr + "</ul>");
                        approvedStr = "";
                    }
                });
                if (prevString.length > 0 && stringList[stringList.length - 1].replace(/<(.*?)>/g, "").trim().slice(-3) == "...") {
                    prevListStr = zfctl.prevListPagination(prevString, maxCharLen);
                    stringList.push("<ul>" + prevListStr[1] + "</ul>");
                    prevListStr[1] = "";
                }
            }
            var stringListTotal = stringList.length;
            if (matchType == "HTML") {
                item.find(".zfctl-item-context-body.active").html(stringList[0]);
            }
            else {
                item.find(".zfctl-item-context-body.active").text(stringList[0]);
            }
            if (stringList.length > 1) {
                item.append(readmoreContainer);
                item.find(".zfctl-rm-count").text(1 + " / " + stringListTotal);
                zfc.keyboardEnterToClick(item.find(".zfctl-btn-prev"));
                item.find(".zfctl-btn-prev:not(.zfctl-btn-hidden)").on('click', function () {
                    if (item.find(".zfctl-btn-prev").hasClass("zfctl-btn-hidden")) {
                        return;
                    }
                    else {
                        if (item.find(".zfctl-item-figure .zfctl-placeholder-image").length == 0) {
                            if (item.find(".zfctl-rm-count").text().split('')[0] == 2) {
                                zfctl.eventHoverOut(item);
                            }
                        }
                        var index = item.find(".zfctl-item-context-body.active").data('index');
                        var active = item.find(".zfctl-item-context-body.active");
                        var activeIndex = active.data('index');
                        if (index - 1 == 0) {
                            active.removeClass('active').css('display', 'none');
                            item.find(".zfctl-item-context-body:first-child").addClass('active').css('display', 'block');
                            item.find(".zfctl-btn-prev").addClass("zfctl-btn-hidden").attr("tabindex", "-1");
                            item.find(".zfctl-item-headline").css('display', 'block');
                        }
                        else if (index - 1 != 0) {
                            item.find(".zfctl-item-headline").css('display', 'none');
                            item.find(".zfctl-item-context-body[data-index='" + (activeIndex - 1) + "']").addClass('active').css('display', 'block');
                            item.find(".zfctl-item-context-body[data-index!='" + (activeIndex - 1) + "']").removeClass('active').css('display', 'none');
                        }
                        if (item.find(".zfctl-btn-next").hasClass("zfctl-btn-hidden")) {
                            item.find(".zfctl-btn-next").removeClass("zfctl-btn-hidden").attr("tabindex", "0");
                        }
                        index = item.find(".zfctl-item-context-body.active").data('index') + 1;
                        item.find(".zfctl-rm-count").text(index + " / " + stringListTotal);
                    }
                });
                item.find(".zfctl-btn-prev").addClass("zfctl-btn-hidden").attr("tabindex", "-1");
                zfc.keyboardEnterToClick(item.find(".zfctl-btn-next"));
                item.find(".zfctl-btn-next:not(.zfctl-btn-hidden)").on('click', function () {
                    if (item.find(".zfctl-btn-next").hasClass("zfctl-btn-hidden")) {
                        return;
                    }
                    else {
                        if (item.find(".zfctl-item-figure .zfctl-placeholder-image").length == 0) {
                            if (item.find(".zfctl-rm-count").text().split('')[0] == 1) {
                                zfctl.eventHoverIn(item);
                            }
                        }
                        var index = item.find(".zfctl-item-context-body.active").data('index');
                        var active = item.find(".zfctl-item-context-body.active");
                        var activeIndex = active.data('index');
                        if (active.length == 0) {
                            active.removeClass('active');
                            item.find(".zfctl-item-headline").css('display', 'none');
                            item.find(".zfctl-item-context-body[data-index='1']").addClass('active').css('display', 'block');
                            item.find(".zfctl-item-context-body[data-index!='1']").css('display', 'none');
                        }
                        else if (index + 1 != stringListTotal) {
                            item.find(".zfctl-item-headline").css('display', 'none');
                            item.find(".zfctl-item-context-body[data-index='" + (activeIndex + 1) + "']").addClass('active').css('display', 'block');
                            item.find(".zfctl-item-context-body[data-index!='" + (activeIndex + 1) + "']").removeClass('active').css('display', 'none');
                        }
                        if (item.find(".zfctl-item-context-body.active").data('index') + 1 == stringListTotal) {
                            item.find(".zfctl-btn-next").addClass("zfctl-btn-hidden").attr("tabindex", "-1");
                        }
                        if (item.find(".zfctl-btn-prev").hasClass("zfctl-btn-hidden")) {
                            item.find(".zfctl-btn-prev").removeClass("zfctl-btn-hidden").attr("tabindex", "0");
                        }
                        index = item.find(".zfctl-item-context-body.active").data('index') + 1;
                        item.find(".zfctl-rm-count").text(index + " / " + stringListTotal);
                    }
                });
                stringList.forEach(function (value) {
                    if (value != stringList[0]) {
                        var htmlStr = "<div class='zfctl-item-context-body' data-index='" + currIndex + "' style='display: none;'>" + value + "</div>";
                        that.find(".zfctl-item-text").append(htmlStr);
                    }
                    currIndex = 1 + currIndex;
                });
            }
            item.addClass("zfctl-pagination-set");
        }
    }
    static initSlick(main) {
        try {
            var maxChar = 120;
            var mainEl = $(main);
            var mobile_slider = main.find('.zfctl-items-mobile-wrapper .zfctl-items');
            var sliderList = [];
            mobile_slider.each(function (index, x) {
                if (!$(x).hasClass('swiper-initialized')) {
                    const swiper = new Swiper('#' + $(x).attr('id'), {
                        modules: [Navigation, Pagination, A11y],
                        normalizeSlideIndex: true,
                        preventClicks: false,
                        preventClicksPropagation: false,
                        breakpoints: {
                            720: {
                                allowTouchMove: false,
                                centeredSlides: false,
                                slidesOffsetBefore: 12,
                                slidesOffsetAfter: 12,
                                spaceBetween: 22,
                                loop: false,
                                loopAddBlankSlides: false,
                                slidesPerView: 'auto',
                                navigation: {
                                    enabled: $(x).find('.zfctl-item').length > 3 ? true : false,
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev'
                                },
                                pagination: {
                                    enabled: $(x).find('.zfctl-item').length > 3 ? true : false,
                                    el: '#' + $(x).attr('id').replace("_slider", "") + '_pagination',
                                    type: 'custom',
                                    clickable: true,
                                    dynamicBullets: false,
                                    renderCustom: function (swiper, current, total) {
                                        var out = '';
                                        for (var i = 1; i < total + 1; i++) {
                                            if (i == current) {
                                                out = out + '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' + i + 1 + '"></button>';
                                            }
                                            else {
                                                out = out + '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' + i + 1 + '"></button>';
                                            }
                                        }
                                        ;
                                        return out;
                                    },
                                },
                            },
                            0: {
                                allowTouchMove: true,
                                centeredSlides: true,
                                spaceBetween: 50,
                                loop: false,
                                loopAddBlankSlides: false,
                                slidesPerView: 'auto',
                                navigation: {
                                    enabled: false,
                                    nextEl: '.swiper-button-next',
                                    prevEl: '.swiper-button-prev'
                                },
                                pagination: {
                                    enabled: $(x).find('.zfctl-item').length > 1 ? true : false,
                                    el: '#' + $(x).attr('id').replace("_slider", "") + '_pagination',
                                    clickable: false,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 1
                                },
                            }
                        },
                        a11y: {
                            enabled: true,
                            nextSlideMessage: 'Next slide',
                            prevSlideMessage: 'Previous slide',
                            paginationBulletMessage: 'Jump to slide {{index}}',
                            slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
                            slideRole: 'group',
                            itemRoleDescriptionMessage: 'slide'
                        }
                    });
                    swiper.init();
                    sliderList.push({ id: $(x).attr('id'), swiper: swiper });
                }
            });
            var timelineID = main.attr('id');
            if (zfctl.checkTimelineIncluded(zfctl.timelineSliders, "id", timelineID) == false) {
                zfctl.timelineSliders.push({ id: main.attr('id'), sliders: sliderList });
            }
            mainEl.find('.zfctl-item-more').off("click").on("click", function (e) {
                e.preventDefault();
                $(this).toggleClass('more-open').siblings(".zfctl-item-text").toggleClass('zfctl-item-context-body-more-open');
                if ($(this).hasClass('more-open')) {
                    var cacheChild = $(this).children();
                    $(this).text(zfTranslations.get("read_less")).append(cacheChild);
                    cacheChild.removeClass('zfcui-icon-arrow-big-thin-r').addClass('zfcui-icon-arrow-big-thin-l');
                }
                else {
                    var cacheChild = $(this).children();
                    $(this).text(zfTranslations.get("read_more")).append(cacheChild);
                    cacheChild.removeClass('zfcui-icon-arrow-big-thin-l').addClass('zfcui-icon-arrow-big-thin-r');
                }
            });
            var dropdownClick = main.find(".zfctl-dropdown-item");
            dropdownClick.each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            mainEl.off("click", ".zfctl-dropdown-item").on("click", ".zfctl-dropdown-item", function () {
                var currTimeline = $(this).closest(".zfctl-timeline");
                var currSelection = currTimeline.find(".zfctl-items-mobile-wrapper .zfctl-mobile-items-container > .zfctl-decade-range:contains(" + $(this).text() + ")");
                var hideOtherSliders = currTimeline.find(".zfctl-items-mobile-wrapper .zfctl-mobile-items-container > .zfctl-decade-range:not(:contains(" + $(this).text() + "))");
                currSelection.closest(".zfctl-mobile-items-container").addClass("zfctl-container-active");
                currSelection.closest(".zfctl-mobile-items-container").css("display", "block");
                currSelection.closest(".zfctl-mobile-items-container").find('.zfctl-item').each(function () {
                    var containsNoImage = $(this).find(".zfctl-item-figure .zfctl-placeholder-image").length;
                    if (containsNoImage) {
                        $(this).find(".zfctl-item-content-bg, .zfctl-item-content, .zfctl-item-text").css("min-height", $(this).outerHeight());
                        $(this).find(".zfctl-item-content").addClass("zfctl-item-content-no-image");
                    }
                });
                hideOtherSliders.closest(".zfctl-mobile-items-container").removeClass("zfctl-container-active");
                hideOtherSliders.closest(".zfctl-mobile-items-container").css("display", "none");
                $(this).closest(".zfctl-select-decade-dropdown").find(".zfctl-dropdown-btn-text").empty().text($(this).text());
                $.each(zfctl.timelineSliders, function (index, x) {
                    if (currTimeline.attr('id') == x.id) {
                        $.each(x.sliders, function (index, y) {
                            if (currSelection.closest('.zfctl-mobile-items-container').find('.zfctl-items').attr('id') == y.id) {
                                y.swiper.update();
                                y.swiper.slideReset();
                                return;
                            }
                        });
                    }
                });
            });
            mainEl.find(".zfctl-video-overlay, .zfctl-item-video-close").each(function () {
                zfc.keyboardEnterToClick($(this));
            });
            mainEl.off("click", ".zfctl-video-overlay").on("click", ".zfctl-video-overlay", function () {
                var videoOverlay = $(this);
                var parent = videoOverlay.parent();
                var headerHeight = $('.zfch2-header2').height() + 30;
                parent.find('.zfctl-item-video-close').css("top", headerHeight).attr("tabindex", "0");
                parent.find(".zfctl-item-video").addClass("zfctl-item-video-popup");
                videoOverlay.closest(".zfctl-items").addClass("zfctl-video-active");
                videoOverlay.closest(".zfctl-item").addClass("zfctl-video-item-active");
                if (parent.find(".zfctl-item-video .zfcfsv-full-size-video").hasClass("delayZFCFSVLoad")) {
                    zfcfsv.initFullSizeVideo(parent.find(".zfctl-item-video .zfcfsv-full-size-video"));
                }
                else {
                    zfcfsv.init();
                }
                zfctl.tryPlayWhenVisible(parent);
            });
            mainEl.off("click", ".zfctl-item-video-close").on("click", ".zfctl-item-video-close", function () {
                var that = $(this);
                if (that.parent().find("video").length > 0) {
                    that.parent().find(".playkit-icon playkit-icon-pause").click();
                }
                that.parent().find(".zfctl-item-video").removeClass("zfctl-item-video-popup");
                that.closest(".zfctl-item").removeClass("zfctl-video-item-active");
                that.closest(".zfctl-items").removeClass("zfctl-video-active");
                that.attr("tabindex", "-1");
            });
            mainEl.find(".zfctl-item").each(function (index, item) {
                zfUtils.loadOnScroll($(item), "delayZFCTLLoad", zfctl.loadImage, 4);
            });
            if (mainEl.data('open')) {
                mainEl.find(".zfctl-group-toggle").click();
            }
            $(main).find(".zfctl-item").each(function () {
                var containsNoImage = $(this).find(".zfctl-item-figure .zfctl-placeholder-image").length;
                if (($(this).hasClass("zfctl-pagination-set") == false) && (($(this).find(".zfctl-item-context-body").text().length > maxChar) || ($(this).find(".zfctl-item-context-body").html().length > maxChar))) {
                    zfctl.eventContentPagination($(this), maxChar);
                }
                else if (($(this).hasClass("zfctl-pagination-set") == false) && (($(this).find(".zfctl-item-context-body").text().length > 350) || ($(this).find(".zfctl-item-context-body").html().length > 350)) && (containsNoImage)) {
                    zfctl.eventContentPagination($(this), 350);
                }
                if (containsNoImage) {
                    $(this).find(".zfctl-item-content-bg, .zfctl-item-content, .zfctl-item-text").css("min-height", $(this).outerHeight());
                    $(this).find(".zfctl-item-content").addClass("zfctl-item-content-no-image");
                }
            });
            $(main).removeClass('delayZFCTimelineLoad');
            $(main).addClass('zfctl-initialized');
        }
        catch (err) {
            console.log("initalization failed: zfctl.init() " + err.message);
        }
    }
    ;
    static checkTimelineIncluded(array, key, value) {
        let exists = false;
        $.each(array, function (index, obj) {
            if (obj.hasOwnProperty(key) && obj[key] === value) {
                exists = true;
                return false;
            }
        });
        return exists;
    }
    ;
    static scrollcheck(frame) {
        var scrollPosTop = frame.getBoundingClientRect().top;
        var height = frame.getBoundingClientRect().height;
        var scrollRatio = (scrollPosTop + height) /
            (window.innerHeight + height);
        if ((scrollRatio >= 0) && (scrollRatio <= 1)) {
            var pane = frame.querySelector('.zfctl-parallax-pane');
            var parallaxY = 10;
            var baseTranslateY = -50;
            pane.style.transform =
                'translateY(' + (scrollRatio * parallaxY * 2 - parallaxY + baseTranslateY) + '%)';
        }
    }
    ;
    static init() {
        $(".zfctl-timeline:not(.zfctl-initialized)").each(function () {
            zfUtils.loadOnScroll($(this), "delayZFCTimelineLoad", zfctl.initSlick);
        });
    }
}
zfctl.timelineSliders = [];
;
try {
    zfUtils.onReady(zfctl.init);
}
catch (err) {
    console.log("initalization failed: zfctl.init() " + err.message);
}
